import { useRef } from "react";

const NAMES = ["top-left", "top-right", "bottom-right", "bottom-left"];

export const CornerEditor = ({ url, width, height, quad, setQuad }) => {
  const box = useRef(null);
  const drag = useRef(null);
  const move = (e) => {
    if (drag.current === null) return;
    const r = box.current.getBoundingClientRect();
    const x = Math.min(width, Math.max(0, ((e.clientX - r.left) / r.width) * width));
    const y = Math.min(height, Math.max(0, ((e.clientY - r.top) / r.height) * height));
    setQuad(quad.map((p, i) => (i === drag.current ? [x, y] : p)));
  };
  return (
    <div ref={box} className="relative mx-auto w-full select-none touch-none overflow-hidden rounded-lg bg-black" style={{ aspectRatio: `${width} / ${height}`, maxWidth: 420 }}
      onPointerMove={move} onPointerUp={() => { drag.current = null; }} onPointerCancel={() => { drag.current = null; }} data-testid="corner-editor">
      <img src={url} alt="Captured document" draggable={false} className="absolute inset-0 h-full w-full" />
      <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" className="absolute inset-0 h-full w-full pointer-events-none">
        <polygon points={quad.map((p) => p.join(",")).join(" ")} fill="rgba(0,229,153,0.14)" stroke="#00E599" strokeWidth={Math.max(width, height) / 220} />
      </svg>
      {quad.map(([x, y], i) => (
        <button key={NAMES[i]} type="button" aria-label={`Drag ${NAMES[i]} corner`} data-testid={`corner-handle-${i}`}
          onPointerDown={(e) => { e.preventDefault(); e.currentTarget.setPointerCapture?.(e.pointerId); drag.current = i; }}
          onPointerMove={move}
          className="absolute h-7 w-7 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-[#00E599] bg-[#0B1017]/70 shadow-[0_0_0_4px_rgba(0,229,153,0.2)] cursor-grab active:cursor-grabbing active:scale-110 transition-transform"
          style={{ left: `${(x / width) * 100}%`, top: `${(y / height) * 100}%` }} />))}
    </div>);
};
